/* globals alert, console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const async = require('async'),
    Backbone = require('backbone'),
    BackboneRadio = require('backbone.radio'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    //
    Contact = require('../models/contact'),
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor').processor,
    helpers = require('../utilities/handlebars').helpers,
    enumerations = require('../utilities/enumerations'),
    templates = require('../utilities/handlebars').templates,
    user = require('../models/user'),
    columns = {
        contactEmail: {
            type: 'text',
            display: 'Email'
        },
        phoneNumbersOnly: {
            type: 'text',
            display: 'Phone'
        },
        organizationRole: {
            type: 'text',
            display: 'Primary'
        },
        programRole: {
            type: 'text',
            display: 'Primary'
        },
        edit: {
            type: 'text',
            display: ''
        }
    },
    EOL = null;

module.exports = Backbone.Collection.extend({
    channels: {
        console: BackboneRadio.channel('console')
    },
    model: Contact,
    columns: function (raw) {
        let a = [];
        a = _.map(this.columnDefinitions, function (column, key) {
            var o = {
                name: key,
                display: column.display,
                src: column.src,
                alt: column.alt
            };
            o[column.type] = true;
            return o;
        });
        return a;
    },
    create: function (serializedValues) {
        if (this.administratorContact) {
            this.createAdministratorContact(serializedValues);
        } else {
            this.createContact(serializedValues);
        }
    },
    createAdministratorContact: function (serializedValues) {
        const processedValues = formProcessor(serializedValues, 'contacts');
        jQuery.ajax({
            contentType: 'application/json',
            data: JSON.stringify(processedValues),
            dataType: 'json',
            headers: user.authorizationHeader('contacts'),
            method: 'POST',
            url: configuration.apiUrlBase + 'adminContact'
        }).done(function (data, statusText, xhr) {
            alert('Administrator created');
            this.reload();
        }.bind(this)).fail(function (xhr, errorText, error) {
            console.log('contact.sync.create.fail - error:%s (%s)', errorText, error.toString());
        });
    },
    attachRole: function (processedValues, callback) {
        // console.log('@acavan - contacts.attachRole', processedValues);
        const paths = {
                program: [
                    'contactProgramRole',
                    processedValues.email || processedValues.contactEmail || processedValues.existingContactId,
                    processedValues.programId || this.id,
                    processedValues.programRoleTypeId
                ],
                organization: [
                    'contactOrganizationRole',
                    processedValues.email || processedValues.contactEmail || processedValues.existingContactId,
                    processedValues.organizationId || this.id,
                    processedValues.organizationRoleTypeId
                ]
            },
            path = paths[this.type].join('/');
        callback = callback || function () {};
        jQuery.ajax({
            contentType: 'application/json',
            dataType: 'json',
            headers: user.authorizationHeader('contacts'),
            // data: JSON.stringify({}),
            method: 'POST',
            url: configuration.apiUrlBase + path
        }).done(function (data, statusText, xhr) {
            if (callback) {callback(null);}
        }).fail(function (xhr, errorText, error) {
            console.error('contact.sync.create.fail - error:%s (%s)', errorText, error.toString());
            if (callback) {callback(errorText);}
        });
    },
    createContact: function (serializedValues, callback) {
        // creates organization or program contact
        const processedValues = formProcessor(serializedValues, 'contacts');
        let contact;
        // @acavan! this is here for now but maybe there should be a role model (e.g. role.assign(contact);)
        // or at least do the role assign in the contact model
        async.waterfall([
            function (callback) {
                if (processedValues.existingContactId === '-1') {
                    contact = new Contact(processedValues);
                    contact.save({}, {
                        success: function (model, response, options) {
                            callback(null);
                        },
                        error: function (model, response, options) {
                            callback('contact.save() failed');
                        }
                    });
                } else {
                    callback(null);
                }
            },
            _.bind(function (callback) {
                this.attachRole(processedValues, callback);
            }, this)
        ], _.bind(function (error) {
            if (!error && (processedValues.organizationRoleTypeId === this.primaryRoleId.toString() || processedValues.programRoleTypeId === this.primaryRoleId.toString())) {
                this.makePrimary(processedValues.contactEmail); // this won't needlessly update the current record but will remove primary from anyone else
            }
            if (callback) {
                callback(error);
            } else {
                if (!error) {
                    this.reload(); // @acavan! for reals?
                } else {
                    console.log('contacts.create - error:%s', error.toString());
                }
            }
        }, this));
    },
    initialize: function (items, options) {
        // console.log('contacts.initialize - options:%s', JSON.stringify(options));
        this.type = options.type; // 'organization' || 'program' || 'administrator'
        this.primaryRoleId = enumerations.codeValues[this.type === 'organization' ? 'organizationRoleTypePrimaryContact' : 'programRoleTypePrimaryContact'];
        this.adminRoleId = enumerations.codeValues[this.type === 'organization' ? 'organizationRoleTypeAdmin' : 'programRoleTypeAdmin'];
        this.columnDefinitions = _.clone(columns);
        if (this.type !== 'administrator') {
            delete this.columnDefinitions[(this.type === 'organization' ? 'program' : 'organization') + 'Role'];
        } else {
            delete this.columnDefinitions.programRole;
            delete this.columnDefinitions.organizationRole;
        }
        this.id = options.id;
        this.full = options.full;
        this.administratorContact = options.type === 'administrator';
        // we might be used sans id by admin contact create...
        this.reload();
    },
    makePrimary: function (id) {
        const roleTypeId =  this.type === 'organization' ? 'organizationRoleTypeId' : 'programRoleTypeId';
        let o;
        if (id !== null) {
            _.each(this.models, _.bind(function (model) {
                if (model.attributes[roleTypeId] !== (model.id === id ? this.primaryRoleId : this.adminRoleId)) {
                    // console.log('@acavan: contacts.makePrimary', model.id, (model.id === id ? this.primaryRoleId : this.adminRoleId));
                    o = {};
                    o[roleTypeId] = (model.id === id ? this.primaryRoleId : this.adminRoleId);
                    model.set(o);
                    o = {contactEmail: model.id};
                    o[roleTypeId] = (model.id === id ? this.primaryRoleId.toString() : this.adminRoleId.toString());
                    this.attachRole(o);
                }
            }, this));
        } else {
            // someone deleted a primary contact so let's try to make someone else a primary contact...
            if (this.models.length > 0) {
                o = {};
                o[roleTypeId] = this.primaryRoleId;
                this.models[0].set(o);
                o = {contactEmail: this.models[0].id};
                o[roleTypeId] = this.primaryRoleId.toString();
                this.attachRole(o);
            }
        }
    },
    reload: function () {
        const urls = {
                administrator: 'adminContacts/',
                organization: 'organizationContacts/',
                program: 'programContacts/'
            };
        let url;
        if (this.type === 'organization' && this.full) {
            url = configuration.apiUrlBase + 'organizationContactsFull/' + (this.id || '-1');
        } else {
            url = configuration.apiUrlBase + urls[this.type] + (this.id || '');
        }
        this.fetch({
            headers: user.authorizationHeader('contacts'),
            method: 'GET',
            reset: true,
            url: url
        });
    },
    rows: function () {
        // @acavan! - perhaps we should just pass a template context in each row and let the consumer call
        // the template as needed rather than emitting html up here in the collection...
        const a = [],
            properties = _.keys(this.columnDefinitions),
            createForm = templates.contactEdit({
                create: true,
                administratorContact: this.type === 'administrator',
                organizationContact: this.type === 'organization',
                organizationId: (this.type === 'organization' ? this.id : null),
                organizationRoleTypeId: -1,
                programContact: this.type === 'program',
                programId: (this.type === 'program' ? this.id : null),
                programRoleTypeId: -1
            });
        a.push({
            context: 'edit',
            colspan: 4,
            edit: true,
            hidden: false,
            values: {
                form: createForm
            }
        });
        if (this.length) {
            _.each(this.models, _.bind(function (model) {
                const json = model.toJSON(),
                    display = {
                        id: json.contactEmail,
                        context: 'display',
                        display: true,
                        values: {}
                    },
                    edit = {
                        id: json.contactEmail,
                        context: 'edit',
                        edit: true,
                        colspan: 4,
                        hidden: true,
                        values: {}
                    };
                json.edit = templates.tableEditButton(_.invert({true: configuration.tableEditButtonStyle}));
                _.each(properties, _.bind(function (property) {
                    switch (property) {
                        case 'phone':
                        case 'phoneNumbersOnly':
                            display.values[property] = helpers.telephone(json[property]);
                            break;
                        case 'organizationRole':
                        case 'programRole':
                            // maybe, just maybe, this is a candidate for conversion to handlebars template...
                            display.values[property] = '<img  src="' + configuration.assetBase + (json[property + 'TypeId'] === this.primaryRoleId ? 'images/contactRolePrimaryYes.svg' : 'images/contactRolePrimaryNo.svg') + '" data-action="make:primary" class="action_enabled column-icon align-text-bottom" data-toggle="popover" data-placement="right" data-content="' + helpers.l10n('feedbackSaved') + '" data-popover-trigger="' + (json[property + 'TypeId'] === this.primaryRoleId ? 'true' : 'false') + '"/><img src="' + configuration.assetBase + (json[property + 'TypeId'] === this.primaryRoleId ? 'images/contactRolePrimaryYes_disabled.svg' : 'images/contactRolePrimaryNo_disabled.svg') + '" data-action="noop" class="action_disabled column-icon align-text-bottom"/>';
                            break;
                        default:
                            display.values[property] = json[property];
                            break;
                    }
                    // display.values[property] = json[property];
                }, this));
                a.push(display);
                edit.values = {
                    form: templates.contactEdit(_.extend({
                        organizationContact: this.type === 'organization',
                        programContact: this.type === 'program'
                    }, json))
                };
                a.push(edit);
            }, this));
        }
        return a;
    },
    sortAttribute: function (attributeOrder) {
        let isAscending;
        if (attributeOrder) {
            isAscending = attributeOrder.order === 'ascending';
            this.attributeOrder = attributeOrder;
            this.reset(_.orderBy(
                this.models,
                function (model) {
                    let value = model.get(attributeOrder.attribute);
                    value = value === 0 ? '0' : value;
                    return value || (isAscending ? '_' : ' '); // force empty values to the end of the sort
                },
                isAscending ? 'asc' : 'desc'
            ));
        }
        return this.attributeOrder;
    },
    update: function (serializedValues) {
        const processedValues = formProcessor(serializedValues, 'contacts');
        let contact,
            keys,
            roleTypePresent;
        if (processedValues.contactEmail) {
            contact = this.get(processedValues.contactEmail);
            delete processedValues.id;
            contact.set(processedValues);
            if (!_.isEmpty(contact.changed)) {
                keys = _.keys(contact.changed);
                roleTypePresent = _.intersection(keys, ['organizationRoleTypeId', 'programRoleTypeId']).length > 0;
                if (keys.length > 1 || !roleTypePresent) {
                    contact.save();
                }
                if (roleTypePresent) {
                    this.attachRole(processedValues);
                    if (this.type === 'organization') {
                        contact.set({organizationRole: helpers.enumL10n({property: 'organizationRoleTypeId', id: processedValues.organizationRoleTypeId})});
                    } else {
                        contact.set({programRole: helpers.enumL10n({property: 'programRoleTypeId', id: processedValues.programRoleTypeId})});
                    }
                }
            }
        } else {
            this.create(serializedValues);
        }
    }
});
